/**
* Content Reveal Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Reveal Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-reveal-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-reveal-cards__card-trigger' ).on( 'click', function() {
        $( '.content-reveal-cards__card' ).not( $( this ).closest( '.content-reveal-cards__card' ) ).removeClass( 'is-open' );
        $( '.content-reveal-cards__card-description' ).not( $( this ).next( '.content-reveal-cards__card-description' ) ).removeClass( 'is-open' ).slideUp();
        $( this ).closest( '.content-reveal-cards__card' ).toggleClass( 'is-open' );
        $( this ).next( '.content-reveal-cards__card-description' ).toggleClass( 'is-open' ).slideToggle();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-reveal-cards', COMPONENT );
} )( app );
